import useStyles from '../styles/global-mui.js';
import {Select, MenuItem, InputLabel, FormControl, Box} from '@mui/material'
import DsasButton from '../v1/components/DsasButton/DsasButton';
import { faArrowRotateRight } from '@fortawesome/free-solid-svg-icons';


const Select_Dsas = ({
    className,
    sx,
    inputRef,
    labelId,
    label,
    selectId,
    name,
    value,
    onChange,
    items,
    onReset,
    open,
    onClick,
    onKeyPress,
    isError,
    editing = false,  // Ajout du paramètre "editing" avec une valeur par défaut de "false"
    onChangeEditing,
    editingValue,
    disabled
  }) => {

    const classes = useStyles();


    const inputLabel = (
      <>
        {editing ? (
          <InputLabel 
            id={labelId} 
            className={classes.customInputLabel} 
            sx={{ position: 'absolute', marginTop: '-9px'}}
            error={isError}
            >
          <input
            type="text"
            value={editingValue}
            error={isError}
            style={{
              fontSize: '16',
              padding: '8px',
            }}
            onChange={(e) => onChangeEditing(e.target.value)}
          />
          </InputLabel>
        ) : (
          <InputLabel id={labelId} className={classes.customInputLabel} sx={{
             
            }}>
          {label}
          </InputLabel>
        )}
      </>
    );

    return (
      <div ref={inputRef}>
        <FormControl fullWidth error={isError}>
          <Box>{inputLabel}</Box>
          <Select
            sx={sx}
            className={classes.customInput}
            error={isError}
            disabled={editing || disabled}
            labelId={labelId}
            id={selectId}
            name={name}
            value={value ?? ""}
            label={label}
            open={open}
            onChange={onChange}
            onClick={onClick}
            onKeyPress={onKeyPress}
          >
            {items &&
              items.map((i) =>
                i && (
                  <MenuItem
                    sx={{
                      fontWeight: i.disabled ? "bold" : "default",
                      fontSize: "default",
                      color: i.disabled ? "var(--color-blue-primary)" : "var(--color-text)",
                      textTransform: i.disabled ? "uppercase" : "none",
                      opacity:'1 !important',
                    }}
                    key={i._id}
                    value={i._id}
                    disabled={i.disabled}
                    className={classes.customListItem}
                  >
                    {i.name ? i.name : `${i.lastname} ${i.firstname}`}
                  </MenuItem>
                )
              )}
          </Select>
          {onReset && 
          <Box className='centered-wrapper'>
            <DsasButton icon={faArrowRotateRight} label="Reset" onClick={onReset} variant = 'secondary'/>
          </Box>
          }
        </FormControl>
      </div>
    );
  };

export default Select_Dsas